import request from './request'

// 获取版本详情请求参数
export interface GetVersionDetailDto {
  versionCode: string
  productManagementId: number
  productType: string
}


// 获取版本详情响应数据
export interface GetVersionDetail {
  /**
     * 是否可操作此记录（如编辑、删除等）
     */
  canOperate?: boolean;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 创建人ID
   */
  createUserId?: number;
  /**
   * 创建人姓名
   */
  createUserName?: string;
  /**
   * 是否逻辑删除（0：否，1：是）
   */
  deleteFlag?: number;
  /**
   * 主键ID
   */
  id?: number;
  /**
   * 产品管理表Id
   */
  productManagementId: number;
  /**
   * 产品类型（如：发薪小程序）
   */
  productType: string;
  /**
   * 更新时间
   */
  updateTime?: string;
  /**
   * 更新人ID
   */
  updateUserId?: number;
  /**
   * 更新人姓名
   */
  updateUserName?: string;
  /**
   * 版本号（如：V1.0.0）
   */
  versionCode: string;
  /**
   * 版本描述
   */
  versionDesc: string;
}

// 获取版本详情
export function getVersionDetail(params: GetVersionDetailDto): Promise<GetVersionDetail> {
  return request.get('/saas/version/notice/getDetail', { params })
}

export interface ProductListReq {
  /**
   * 当前记录起始索引
   */
  pageNum: string;
  /**
   * 每页显示记录数
   */
  pageSize: string;
  /**
   * 所属平台(微信-小程序、支付宝-小程序、pc、app)
   */
  platform?: string;
  /**
   * 产品名称
   */
  productName?: string;
  /**
   * 产品状态(0:下线,1:启用)
   */
  status?: number;
  [property: string]: any;
}

/**
 * 分页产品列表
 *
 * TableDataInfoListSaasProductManagement
 */
export interface ProductListDto {
  /**
   * 消息状态码
   */
  code?: number;
  /**
   * 消息内容
   */
  msg?: string;
  /**
   * 列表数据
   */
  rows?: SaasProductManagement[];
  /**
   * 总记录数
   */
  total?: number;
  [property: string]: any;
}

/**
* com.lthd.saas.system.domain.SaasProductManagement
*
* SaasProductManagement
*/
export interface SaasProductManagement {
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 创建人ID
   */
  createUserId?: number;
  /**
   * 主键ID
   */
  id?: number;
  /**
   * 所属平台(微信-小程序、支付宝-小程序、pc、app)
   */
  platform?: string;
  /**
   * 产品ID(001开头)
   */
  productId?: string;
  /**
   * 产品名称
   */
  productName?: string;
  /**
   * 产品类型 （名称+所属平台
   */
  productType?: string;
  /**
   * 产品状态(0:下线,1:启用)
   */
  status?: number;
  /**
   * 更新时间
   */
  updateTime?: string;
  /**
   * 更新人ID
   */
  updateUserId?: number;
  /**
   * 当前版本号
   */
  version?: string;
  [property: string]: any;
}

// 查询产品列表（支持条件筛选）
export function getProductList(params: ProductListReq): Promise<ProductListDto> {
  return request.get('/saas/product/management/searchProductList', { params })
}

